import { BoardedPersonnel } from "./BoardedPersonnel";
export default BoardedPersonnel;
